// A custom base key for use with the useAccountEventList hook, so that we can exclude the timestamp
export const accountEventsQueryKey = ['/custom/account/events'];

// A list of queries to be invalidated when an event corresponding to a query key in the accountEventsListQueryKey list is seen
// - this is the base key only, it will be augmented with values before being added to the cache
// - not persisted
export const accountEventsEntryQueryKey = [
  '/custom/account/events/invalidate/entry',
];

// A list of augmented accountEventsEntryQueryKeys that correspond to tenant events that we are watching for
// - not persisted
export const accountEventsListQueryKey = [
  '/custom/account/events/invalidate/list',
];
